module.exports = __webpack_public_path__ + "img/02.e6c22afb.jpg";